import { PlainButton } from 'components/Button'
import Triangle from 'components/Triangle'
import { actions, selectors } from 'data'
import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import styled from 'styled-components'
import { fontSize } from 'utils'

import { languages } from '../../providers/ConnectedIntl/languages'

const Button = styled(PlainButton)`
  padding: 0;
  font-size: ${fontSize('sm')};
`

type PropsType = ConnectedProps<typeof connector>

const LanguageToggler = ({ language, showLanguageModal }: PropsType) => (
  <Button e2e='languageTogglerButton' onClick={showLanguageModal}>
    {languages[language]}
    <Triangle direction='down' />
  </Button>
)

const mapStateToProps = (state) => ({
  language: selectors.app.getLanguage(state)
})

const mapDispatchToProps = (dispatch) => ({
  showLanguageModal: () => {
    dispatch(actions.app.showModal('LANGUAGE_SELECTION', { fullscreen: true }))
    dispatch(actions.app.setModalDismissable(true))
  }
})

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(LanguageToggler)
